function initHeroVideoYoutube() {
  var videoAspectRatio = 28.125;
  var videoPlayerInitiated = false;
  initVideoPlayer();
  window.addEventListener('resize', initVideoPlayer);
  function initVideoPlayer() {
    if (window.innerWidth >= 722) {
      if (!document.body.classList.contains('CampaignPage-top-level') && !videoHero.parentElement.parentElement.classList.contains('hero-carousel-block__wrapper')) {
        videoHero.style.paddingTop = videoHero.querySelector('.video-wrapper').offsetWidth / 100 * videoAspectRatio - 1 + 'px';
      }

      if (!videoPlayerInitiated) {
        initializeVideoYoutubeControls(videoHero);
        videoPlayerInitiated = true;
      }
      videoHero.style.backgroundImage = null;
      videoHero.querySelector('.video-player').style.backgroundImage = "url(" + videoHero.querySelector('.js-video-placeholder').getAttribute('data-poster') + ")";
    }
    else if (window.innerWidth < 722) {
      videoHero.style.paddingTop = '';
      videoHero.style.backgroundImage = "url(" + videoHero.getAttribute('data-mobile-image') + ")";
    }
  }
}

// Make the function globally available
window.initHeroVideoYoutube = initHeroVideoYoutube;

(function () {
  var videoHero = document.querySelector('.youtube-video-hero');
  if (!videoHero || !videoHero.querySelector('.js-video-placeholder')) {
    return;
  }
  var mobileImageLoaded = false;
  handleMobileOrDesktop();
  window.addEventListener('resize', handleMobileOrDesktop);

  function handleVideoPluginLoad() {
    if (document.getElementsByTagName('body')[0].classList.contains('has-piwik')) {
      initVideoIfMarketingCookiesAccepted(initHeroVideoYoutube);
    }
    else {
      initHeroVideoYoutube();
    }
  }

  function handleMobileOrDesktop() {
    if (window.innerWidth >= 722) {
      handleVideoPluginLoad();
    }
    else if (!mobileImageLoaded) {
      videoHero.style.backgroundImage = "url(" + videoHero.getAttribute('data-mobile-image') + ")";
      mobileImageLoaded = true;
    }
  }
})();